import { InjectionToken } from '@angular/core';

export const SOFTLINE_MODULE_BELEGLESER = 'Belegleser';

// Keep in sync with the literal in src/federation/module-metadata.ts.
export const SOFTLINE_PERMISSION_BELEGLESER = 'SOFTAPPS.BELEGLESER';

export interface BelegleserConfig {
  /** Base URL of the belegleser service. Must stay relative — the JWT interceptor has no URL filter. */
  apiBaseUrl?: string;
  /** Delay between two `GET /jobs/{id}` polls while a job is being read. */
  pollIntervalMs?: number;
  /** Overall poll budget before the page reports a timeout. */
  pollTimeoutMs?: number;
  /** Path of the service's field schema, relative to `apiBaseUrl`. */
  fieldSchemaPath?: string;
}

export const DEFAULT_BELEGLESER_CONFIG: Required<BelegleserConfig> = {
  apiBaseUrl: '/ai-belegleser/api',
  pollIntervalMs: 1000,
  pollTimeoutMs: 300_000,
  // Agreed with the service team (template format v3); not in OpenAPI 0.1.0 yet.
  fieldSchemaPath: '/schema/fields',
};

export const SOFTLINE_CONFIG_BELEGLESER = new InjectionToken<BelegleserConfig>(
  'SOFTLINE_CONFIG_BELEGLESER',
  { factory: () => DEFAULT_BELEGLESER_CONFIG }
);

/** Defaults for every key the caller left out or passed as `undefined`. */
export function belegleserConfig(config: BelegleserConfig): Required<BelegleserConfig> {
  const defined = Object.entries(config).filter(([, value]) => value !== undefined);
  return { ...DEFAULT_BELEGLESER_CONFIG, ...Object.fromEntries(defined) };
}
